import videoPlayerConfigSlice from './slice';

export const { setMuted, setVolume } = videoPlayerConfigSlice.actions;
